import React from 'react';
import vega from 'vega';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

class VegaChart extends React.Component {

  componentDidMount() {
    this.resizeEvent = () => {
      this.handleResize();
    };
    window.addEventListener('resize', debounce(this.resizeEvent, 100));

    this.renderChart();
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps.data, this.props.data);
  }

  componentDidUpdate() {
    this.renderChart();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeEvent);
  }

  setSize() {
    if (this.chart) {
      this.width = this.chart.offsetWidth;
      this.height = this.chart.offsetHeight;
    }
  }

  parseVega() {
    const defaultPadding = { left: 10, right: 10 };
    const padding = this.props.data.padding && typeof this.props.data.padding === 'number' ?
      this.props.data.padding : defaultPadding;
    const size = {
      width: this.width - padding.left - padding.right,
      height: this.props.data.height || 260
    };
    const data = Object.assign({}, this.props.data, size);

    this.props.toggleLoading(true);
    vega.parse.spec(data, {}, (err, chart) => {
      this.props.toggleLoading(false);
      if (!err) {
        this.vis = chart({
          el: this.chart,
          renderer: 'svg'
        });
        this.vis.update();
      }
    });
  }

  handleResize() {
    this.renderChart();
  }

  renderChart() {
    this.setSize();
    this.parseVega();
  }

  render() {
    return (
      <div className="c-chart">
        <div ref={(c) => { this.chart = c; }} className="chart" />
      </div>
    );
  }
}

VegaChart.propTypes = {
  data: React.PropTypes.any.isRequired,
  toggleLoading: React.PropTypes.func
};

export default VegaChart;



// WEBPACK FOOTER //
// ./app/components/common/vega/VegaChart.jsx